var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BizSelector',{on:{"select":_vm.select}}),_c('List',{attrs:{"reviews":_vm.reviews}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }